export const RESET = 'EXSBINVOICE_UPDATE_RESET'
export const SET_ERROR = 'EXSBINVOICE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBINVOICE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBINVOICE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBINVOICE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBINVOICE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBINVOICE_UPDATE_UPDATE_RETRIEVED'
